<template>
  <div id="qr-code-scan-container">
    <div id="qr-code-scan">
      <qrcode-stream :camera="camera" :track="paintOutline" @decode="onDecode" @init="onInit">
        <div class="loading" v-if="loading">
          Camera is starting...
        </div></qrcode-stream
      >
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  name: 'QrCodeScan',
  components: {
    QrcodeStream,
  },
  computed: {},
  data() {
    return {
      camera: 'rear',
      loading: false,
    };
  },
  methods: {
    onDecode(data) {
      this.camera = 'off';
      this.$emit('qr-code-scan-success', data);
    },

    async onInit(promise) {
      this.loading = true;

      try {
        await promise;
      } catch (error) {
        console.error(error);
        this.$emit('qr-code-scan-error');
      } finally {
        this.loading = false;
      }
    },

    paintOutline(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;

        ctx.strokeStyle = 'red';

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/_variables.scss";
@import "../../styles/_reset.scss";

#qr-code-scan-container {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 75%;
  height: 250px;
  padding: 5px;

  #qr-code-scan {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loading {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
